import { createContext, useContext, useEffect, useState } from "react"
import IPassword from "../shared/Password"
import PassApi from "./PassApi"

export type TPasswordProviderContext = {
    passwords:IPassword[]
}

const PasswordProviderContext = createContext<TPasswordProviderContext>({passwords:[]})
export const usePassword = () => useContext(PasswordProviderContext)

export default function PasswordProvider(props:{children:any}) {
    const [passwords,setPasswords] = useState<IPassword[]>([])
    const onRefresh = (passwords:IPassword[]) => setPasswords(passwords)
    useEffect(() => {
        PassApi.i.on("refresh", onRefresh)
        return () => { PassApi.i.removeListener("refresh", onRefresh) }
    }, [])
    return <PasswordProviderContext.Provider value={{passwords}}>{props.children}</PasswordProviderContext.Provider>
}